import React from 'react';
import PublicLayout from '../components/PublicLayout';
import { useTranslation } from 'react-i18next';
import { KvkkSEO } from '../components/SEO';
import { FloatingShapes } from '../components/icons/FeatureIcons';
import { CheckCircle2 } from 'lucide-react';

const Kvkk = () => {
  const { t } = useTranslation();
  const items = [
    t('pages.kvkk.item1'),
    t('pages.kvkk.item2'),
    t('pages.kvkk.item3'),
    t('pages.kvkk.item4')
  ];

  return (
    <PublicLayout>
      <KvkkSEO />
      
      {/* Hero Section */}
      <div className="relative bg-gradient-to-br from-purple-600 to-indigo-700 py-20 overflow-hidden">
        <FloatingShapes />
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
          <p className="text-sm font-semibold text-purple-200 uppercase tracking-wide mb-4">{t('footer.legal')}</p>
          <h1 className="text-4xl sm:text-5xl font-bold tracking-tight text-white mb-6">{t('pages.kvkk.title')}</h1>
          <p className="text-xl text-purple-100 max-w-2xl mx-auto">{t('pages.kvkk.subtitle')}</p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 -mt-10 relative z-10">
        <div className="p-8 border border-gray-100 rounded-2xl shadow-xl bg-white space-y-4">
          {items.map((item, idx) => (
            <div key={idx} className="flex items-start gap-3 p-4 rounded-xl bg-gray-50 hover:bg-purple-50 transition-colors">
              <CheckCircle2 className="w-5 h-5 text-purple-600 flex-shrink-0 mt-0.5" />
              <p className="text-gray-700 leading-relaxed">{item}</p>
            </div>
          ))}
        </div>
      </div>
    </PublicLayout>
  );
};

export default Kvkk;
